export const LOOKUP_KEY = "trustmaster_licenza_una_tantum";

export const translations = {
  it: {
    nav: {
      tagline: "London · Cloud Platform",
      modules: "19 Moduli",
      license: "Licenza €2.999",
      security: "ISO/IEC 27001",
      contact: "Contatto",
      buy: "Acquista Licenza",
      openMenu: "Apri menu",
      closeMenu: "Chiudi menu",
    },
    hero: {
      badge: "SURE MASTER CONSULTING LTD · LONDON",
      line1: "Il software gestionale",
      line2: "per trustee professionali.",
      description:
        "19 moduli integrati, contabilità a partita doppia, antiriciclaggio e Claude AI: trust illimitati con licenza una tantum €2.999.",
      buy: "Acquista Licenza €2.999",
      demo: "Richiedi Demo",
      console: "Console Trust Master",
      live: "LIVE · AES-256",
      fundLabel: "Fondo Fiduciario Attivo",
      fundName: "Trust Aurum International",
      amlLabel: "Stato AML",
      amlValue: "Verificato",
      aiLabel: "Motore AI Integrato",
      aiName: "Claude AI Assistant",
      aiValue: "Attivo",
      foot1: "Trust Illimitati",
      foot2: "19 Moduli Sincronizzati",
    },
    marquee: [
      "Trust Illimitati",
      "Licenza Una Tantum €2.999",
      "Certificato ISO/IEC 27001:2022",
      "Claude AI Integrata",
      "Partita Doppia Fiduciaria",
      "WhatsApp Business API",
      "Backup Cifrati AES-256",
    ],
    modules: {
      eyebrow: "Architettura Gestionale",
      title: "19 Moduli Nativi. Unica Piattaforma.",
      lead: "Dalla tenuta fiduciaria all'antiriciclaggio avanzato, senza costi mensili aggiuntivi.",
      featured: [
        {
          title: "Contabilità a Partita Doppia",
          text: "Piani dei conti dedicati per singoli trust, rendicontazione analitica e bilanci automatici.",
        },
        {
          title: "Antiriciclaggio & KYC",
          text: "Fascicolo antiriciclaggio digitale, verifica del titolare effettivo e audit trail immutabile.",
        },
        {
          title: "Claude AI & Automazione",
          text: "Analisi documentale intelligente, sintesi verbali e reportistica fiduciaria in pochi secondi.",
        },
      ],
      chips: [
        "Dashboard & Gestione Trust",
        "Anagrafiche Soggetti e Ruoli",
        "Tracciamento Beni Patrimoniali",
        "Archivio Documentale Avanzato",
        "Scadenzario & Compliance",
        "Gestione Fiscale e Dichiarazioni",
        "Email Integrata per Trust",
        "Google Calendar",
        "Notifiche e Avvisi",
        "WhatsApp Business API",
        "App Mobile Fiduciaria",
        "Report Word/PDF",
        "Backup Automatico",
        "Firma Elettronica YouSign",
        "Registro Eventi di Audit",
        "Impostazioni Tecniche",
      ],
      bandAlt: "Panoramica dei moduli operativi di Trust Master CRM",
    },
    security: {
      eyebrow: "Standard Istituzionale",
      cert: "ISO/IEC 27001:2022",
      certText:
        "Crittografia AES-256 a riposo e in transito, backup cifrati e conformità certificata per la massima riservatezza patrimoniale.",
      title: "Riservatezza assoluta per società fiduciarie",
      text: "Progettato per studi legali, family office e trustee professionali che richiedono sovranità totale sui dati e conformità fiduciaria.",
      badges: ["Trustee Illimitati", "Nessuna Royalty Ricorrente"],
    },
    pricing: {
      eyebrow: "Investimento Trasparente",
      title: "Licenza Professionale Completa",
      badge: "Una Tantum · Senza Canoni",
      plan: "Licenza Illimitata Trust Master",
      price: "€2.999",
      priceNote: "una tantum + IVA",
      intro: "Include tutti i 19 moduli, supporto all'attivazione e trust illimitati senza canoni mensili.",
      inclusions: [
        "Tutti i 19 moduli operativi inclusi",
        "Numero illimitato di trust gestibili",
        "Motore Claude AI & WhatsApp API integrati",
        "Pagamento sicuro con carta / Stripe",
      ],
      buy: "Procedi all'Acquisto Diretto (€2.999)",
      secure: "Transazione protetta con crittografia SSL / Stripe",
      checkoutError: "Non è stato possibile avviare il pagamento. Riprova tra poco.",
      loading: "Reindirizzamento a Stripe…",
    },
    faq: {
      eyebrow: "Domande Frequenti",
      title: "Tutto chiaro, prima dell'acquisto",
      items: [
        {
          q: "Quali sono i 19 moduli inclusi nel CRM?",
          a: "I 19 moduli coprono: Dashboard, Gestione Trust, Anagrafiche Soggetti, Patrimonio, Archivio Documentale, Scadenzario, Contabilità, Gestione Fiscale, Antiriciclaggio, Email Integrata, Google Calendar, Claude AI, Notifiche, WhatsApp Business, App Mobile, Report Export, Impostazioni Tecniche, Backup Automatico e Sistema di Log.",
        },
        {
          q: "Qual è il prezzo della licenza?",
          a: "La licenza professionale completa costa €2.999,00 una tantum con trust illimitati. Include tutti i 19 moduli, integrazioni, aggiornamenti per 12 mesi e supporto tecnico dedicato. Non ci sono costi ricorrenti o abbonamenti mensili.",
        },
        {
          q: "Quanto tempo richiede l'implementazione?",
          a: "L'implementazione richiede tipicamente 2-4 settimane a seconda della complessità e della mole di dati da migrare. Forniamo supporto completo durante setup, formazione del team e migrazione dal sistema precedente.",
        },
        {
          q: "È possibile migrare i dati dal vecchio sistema?",
          a: "Sì, supportiamo la migrazione completa di anagrafiche, documenti, patrimonio, contabilità e dati storici da qualsiasi sistema precedente, gestita interamente dal nostro team.",
        },
        {
          q: "Quali sono i requisiti tecnici?",
          a: "Trust Master CRM è basato su cloud e accessibile da qualsiasi browser moderno, senza installazioni locali. Funziona su desktop, tablet e smartphone, con app mobile nativa per iOS e Android.",
        },
        {
          q: "Come sono protetti i dati?",
          a: "Tutti i dati sono crittografati in transito (SSL/TLS) e a riposo, con backup automatici giornalieri cifrati. Conformità GDPR e standard internazionali di sicurezza ISO/IEC 27001.",
        },
      ],
    },
    contact: {
      eyebrow: "Richiesta Informazioni",
      title: "Contatta il Team Specialistico",
      direct: "Email diretta: info@trustmastercrm.it",
      nameLabel: "Nominativo / Studio Legale",
      emailLabel: "Email di Contatto",
      messageLabel: "Messaggio / Richiesta Demo",
      submit: "Invia Richiesta al Team",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti risponderemo al più presto.",
      error: "Non è stato possibile inviare la richiesta. Riprova tra poco.",
    },
    chat: {
      title: "Assistente Trust Master",
      subtitle: "Risponde alle domande sul prodotto",
      welcome: "Buongiorno, sono l'assistente di Trust Master CRM. Posso aiutarti con domande su moduli, licenza, implementazione e integrazioni.",
      placeholder: "Scrivi la tua domanda…",
      send: "Invia messaggio",
      openLabel: "Apri la chat",
      closeLabel: "Chiudi la chat",
      error: "Si è verificato un problema. Riprova o scrivici a info@trustmastercrm.it.",
    },
    legal: { privacy: "Privacy Policy", cookies: "Cookie Policy" },
    footer: {
      company: "SURE MASTER CONSULTING LTD",
      address: "Company number 06234182 · Unit 3, Office A, 1st Floor · 6-7 St. Mary At Hill · London, England, EC3R 8EE",
      compliance: "ISO/IEC 27001:2022 Compliant · Trust Master CRM ©",
    },
    payment: {
      successTitle: "Pagamento completato",
      successText: "Grazie per l'acquisto della Licenza Professionale Trust Master CRM. Riceverai a breve le istruzioni di attivazione via email.",
      pendingTitle: "Verifica del pagamento in corso…",
      pendingText: "Stiamo confermando la transazione con Stripe.",
      failedTitle: "Pagamento non confermato",
      failedText: "La transazione non risulta completata. Se l'addebito è avvenuto, contattaci a info@trustmastercrm.it.",
      cancelTitle: "Pagamento annullato",
      cancelText: "Nessun addebito è stato effettuato. Puoi riprendere l'acquisto in qualsiasi momento.",
      back: "Torna alla Home",
    },
  },
  en: {
    nav: {
      tagline: "London · Cloud Platform",
      modules: "19 Modules",
      license: "Licence €2,999",
      security: "ISO/IEC 27001",
      contact: "Contact",
      buy: "Buy Licence",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    hero: {
      badge: "SURE MASTER CONSULTING LTD · LONDON",
      line1: "The management platform",
      line2: "for professional trustees.",
      description:
        "19 integrated modules, double-entry accounting, AML and Claude AI: unlimited trusts with a one-off €2,999 licence.",
      buy: "Buy Licence €2,999",
      demo: "Request a Demo",
      console: "Trust Master Console",
      live: "LIVE · AES-256",
      fundLabel: "Active Fiduciary Fund",
      fundName: "Trust Aurum International",
      amlLabel: "AML Status",
      amlValue: "Verified",
      aiLabel: "Integrated AI Engine",
      aiName: "Claude AI Assistant",
      aiValue: "Active",
      foot1: "Unlimited Trusts",
      foot2: "19 Modules Synchronised",
    },
    marquee: [
      "Unlimited Trusts",
      "One-off Licence €2,999",
      "ISO/IEC 27001:2022 Certified",
      "Integrated Claude AI",
      "Fiduciary Double-Entry",
      "WhatsApp Business API",
      "AES-256 Encrypted Backups",
    ],
    modules: {
      eyebrow: "Management Architecture",
      title: "19 Native Modules. One Platform.",
      lead: "From fiduciary record-keeping to advanced anti-money laundering, with no added monthly costs.",
      featured: [
        {
          title: "Double-Entry Accounting",
          text: "Dedicated charts of accounts per trust, analytical reporting and automatic statements.",
        },
        {
          title: "AML & KYC",
          text: "Digital AML file, beneficial-owner verification and an immutable audit trail.",
        },
        {
          title: "Claude AI & Automation",
          text: "Intelligent document analysis, minute summaries and fiduciary reporting in seconds.",
        },
      ],
      chips: [
        "Dashboard & Trust Management",
        "Party Records and Roles",
        "Asset Tracking",
        "Advanced Document Archive",
        "Deadlines & Compliance",
        "Tax Management and Returns",
        "Integrated Trust Email",
        "Google Calendar",
        "Notifications and Alerts",
        "WhatsApp Business API",
        "Fiduciary Mobile App",
        "Word/PDF Reports",
        "Automatic Backup",
        "YouSign e-Signature",
        "Audit Event Log",
        "Technical Settings",
      ],
      bandAlt: "Overview of Trust Master CRM operational modules",
    },
    security: {
      eyebrow: "Institutional Standard",
      cert: "ISO/IEC 27001:2022",
      certText:
        "AES-256 encryption at rest and in transit, encrypted backups and certified compliance for the highest level of asset confidentiality.",
      title: "Absolute confidentiality for fiduciary firms",
      text: "Built for law firms, family offices and professional trustees requiring full data sovereignty and fiduciary compliance.",
      badges: ["Unlimited Trustees", "No Recurring Royalties"],
    },
    pricing: {
      eyebrow: "Transparent Investment",
      title: "Complete Professional Licence",
      badge: "One-off · No Fees",
      plan: "Trust Master Unlimited Licence",
      price: "€2,999",
      priceNote: "one-off + VAT",
      intro: "Includes all 19 modules, onboarding support and unlimited trusts with no monthly fees.",
      inclusions: [
        "All 19 operational modules included",
        "Unlimited number of trusts",
        "Claude AI engine & WhatsApp API integrated",
        "Secure card payment / Stripe",
      ],
      buy: "Proceed to Direct Purchase (€2,999)",
      secure: "Transaction protected with SSL encryption / Stripe",
      checkoutError: "We could not start the payment. Please try again shortly.",
      loading: "Redirecting to Stripe…",
    },
    faq: {
      eyebrow: "Frequently Asked Questions",
      title: "Everything clear before you buy",
      items: [
        {
          q: "Which 19 modules are included in the CRM?",
          a: "The 19 modules cover: Dashboard, Trust Management, Party Records, Assets, Document Archive, Deadlines, Accounting, Tax Management, Anti-Money Laundering, Integrated Email, Google Calendar, Claude AI, Notifications, WhatsApp Business, Mobile App, Report Export, Technical Settings, Automatic Backup and Audit Log.",
        },
        {
          q: "What is the licence price?",
          a: "The complete professional licence is €2,999.00 as a one-off payment with unlimited trusts. It includes all 19 modules, integrations, 12 months of updates and dedicated technical support. No recurring fees or monthly subscriptions.",
        },
        {
          q: "How long does implementation take?",
          a: "Implementation typically takes 2–4 weeks depending on complexity and data volume. We provide full support during setup, team training and migration from your previous system.",
        },
        {
          q: "Can data be migrated from an existing system?",
          a: "Yes. We support complete migration of party records, documents, assets, accounting and historical data from any previous system, managed entirely by our team.",
        },
        {
          q: "What are the technical requirements?",
          a: "Trust Master CRM is cloud-based and works in any modern browser with no local installation. It runs on desktop, tablet and smartphone, with a native iOS and Android app.",
        },
        {
          q: "How is data protected?",
          a: "All data is encrypted in transit (SSL/TLS) and at rest, with daily encrypted automatic backups. GDPR compliant and aligned with ISO/IEC 27001 international security standards.",
        },
      ],
    },
    contact: {
      eyebrow: "Information Request",
      title: "Contact the Specialist Team",
      direct: "Direct email: info@trustmastercrm.it",
      nameLabel: "Name / Law Firm",
      emailLabel: "Contact Email",
      messageLabel: "Message / Demo Request",
      submit: "Send Request to the Team",
      sending: "Sending…",
      success: "Request sent. We will get back to you shortly.",
      error: "Your request could not be sent. Please try again shortly.",
    },
    chat: {
      title: "Trust Master Assistant",
      subtitle: "Answers product questions",
      welcome: "Hello, I am the Trust Master CRM assistant. I can help with questions about modules, licensing, implementation and integrations.",
      placeholder: "Type your question…",
      send: "Send message",
      openLabel: "Open chat",
      closeLabel: "Close chat",
      error: "Something went wrong. Please try again or email us at info@trustmastercrm.it.",
    },
    legal: { privacy: "Privacy Policy", cookies: "Cookie Policy" },
    footer: {
      company: "SURE MASTER CONSULTING LTD",
      address: "Company number 06234182 · Unit 3, Office A, 1st Floor · 6-7 St. Mary At Hill · London, England, EC3R 8EE",
      compliance: "ISO/IEC 27001:2022 Compliant · Trust Master CRM ©",
    },
    payment: {
      successTitle: "Payment completed",
      successText: "Thank you for purchasing the Trust Master CRM Professional Licence. You will receive activation instructions by email shortly.",
      pendingTitle: "Verifying your payment…",
      pendingText: "We are confirming the transaction with Stripe.",
      failedTitle: "Payment not confirmed",
      failedText: "The transaction does not appear completed. If you were charged, contact us at info@trustmastercrm.it.",
      cancelTitle: "Payment cancelled",
      cancelText: "No charge was made. You can resume your purchase at any time.",
      back: "Back to Home",
    },
  },
};
